import { Paper } from '@mantine/core';
import { useEffect, useMemo, useState } from 'react';
import ObjectFieldsSection from './ObjectFieldsSection';

interface BrowserPerformanceInfo {
  usedJSHeapSize?: string;
  totalJSHeapSize?: string;
  jsHeapSizeLimit?: string;
  heapUsageRatio?: string;
  uasmBytes?: string;
  uasmBreakdown?: any;
  deviceMemory?: string;
  hardwareConcurrency?: number;
  userAgent?: string;
}

const BrowserPerformanceSection = ({ opened }: { opened: boolean }) => {
  const [info, setInfo] = useState<BrowserPerformanceInfo | undefined>();

  const fmtBytes = (n?: number) =>
    typeof n === 'number' ? `${(n / (1024 * 1024)).toFixed(2)} MB` : 'N/A';

  useEffect(() => {
    if (!opened) return;
    const read = async () => {
      const info: BrowserPerformanceInfo = {};
      info.deviceMemory = fmtBytes((navigator as any).deviceMemory);
      info.hardwareConcurrency = navigator.hardwareConcurrency;
      info.userAgent = navigator.userAgent;
      const m: any = (performance as any).memory;
      if (m) {
        info.usedJSHeapSize = fmtBytes(m.usedJSHeapSize);
        info.totalJSHeapSize = fmtBytes(m.totalJSHeapSize);
        info.jsHeapSizeLimit = fmtBytes(m.jsHeapSizeLimit);
        if (m.usedJSHeapSize && m.totalJSHeapSize) {
          info.heapUsageRatio = `${(
            (m.usedJSHeapSize / m.totalJSHeapSize) *
            100
          ).toFixed(2)}%`;
        }
      }
      if ('measureUserAgentSpecificMemory' in performance) {
        try {
          const res = await (
            performance as any
          ).measureUserAgentSpecificMemory();
          info.uasmBytes = fmtBytes(res?.bytes);
          info.uasmBreakdown = res?.breakdown;
        } catch {}
      }
      setInfo(info);
    };
    void read();
    const id = setInterval(read, 15000);
    return () => clearInterval(id);
  }, [opened]);

  return (
    <ObjectFieldsSection document={info} title='Browser Performance & Memory' />
  );
};

export default BrowserPerformanceSection;
